import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useFlow } from "../context/FlowContext";
import { useI18N } from '../context/I18NContext';
import useWidgetStore from '../store/useWidgetStore';
import ConfigHolder from '../config/ConfigHolder';
import { useSettings } from '../context/SettingsContext';
import { useOAuthLogin } from '../hooks/query/useOAuthLogin';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import ErrorAlert from './ErrorAlert';
export default function ExternalLogin(props) {
    const flow = useFlow();
    const { t } = useI18N();
    const theme = useTheme();
    const { api_key } = useSettings();
    const { language, isGuest, setConsumer, setIsAccount, setIsGuest, setIsLoginAccount, setIsNewAccount, } = useWidgetStore();
    const [error, setError] = useState();
    const navigate = useNavigate();
    const formContextOAuth = useForm({});
    const oauthSigninQuery = useOAuthLogin(formContextOAuth);
    const [disabled, setDisabled] = useState(false);
    const _onOAuthOpen = (popupData) => {
        setDisabled(true);
    };
    const _onOAuthClose = (popupData) => {
        setDisabled(false);
    };
    const _onOAuthComplete = (data, popupData) => {
        if (data.token) {
            formContextOAuth.setValue('token', data.token);
            oauthSigninQuery.refetch();
        }
        else {
            //TODO: show error message
            if (data.error) {
                setError([data.error]);
            }
        }
        return false;
    };
    useEffect(() => {
        var _a;
        if (oauthSigninQuery.data) {
            if (oauthSigninQuery.data.status.status === 'failed') {
                setError([oauthSigninQuery.data.status.message]);
            }
            else {
                let _consumer = oauthSigninQuery.data.result.item;
                if (_consumer.provisional === 2) {
                    setConsumer({
                        id: _consumer.id,
                        hash: _consumer.hash
                    });
                    navigate(`/oa_widget_passwordReset`);
                }
                else {
                    const consumer = {
                        id: _consumer.id,
                        hash: _consumer.hash,
                        companyId: _consumer.companyId,
                        provisional: 0,
                        firstName: _consumer.firstName,
                        insertions: _consumer.insertions,
                        lastName: _consumer.lastName,
                        email: _consumer.email,
                        address: _consumer.address,
                        houseNumber: _consumer.houseNr,
                        zipcode: _consumer.zipcode,
                        city: _consumer.city,
                        country: (_a = _consumer.country) !== null && _a !== void 0 ? _a : 'nl',
                        type: _consumer.type,
                        fields: {},
                        contracts: []
                    };
                    if (_consumer.address) {
                        // in case we have a split field, the address goes into the street input element
                        consumer.street = _consumer.address;
                    }
                    if (_consumer.phone) {
                        consumer.phone = _consumer.phone;
                    }
                    if (_consumer.mobile) {
                        consumer.mobile = _consumer.mobile;
                    }
                    for (const [_key, _value] of Object.entries(_consumer)) {
                        if (_key.startsWith('custom-field')) {
                            // @ts-ignore
                            consumer.fields[_key] = _value && _value !== 'null' ? _value : '';
                        }
                        else if (_key.startsWith('acceptTerms')) {
                            if (!consumer.contracts.includes('acceptTerms')) {
                                consumer.contracts.push('acceptTerms');
                            }
                        }
                        else if (_key.startsWith('acceptPrivacy')) {
                            if (!consumer.contracts.includes('acceptPrivacy')) {
                                consumer.contracts.push('acceptPrivacy');
                            }
                        }
                    }
                    if (_consumer.type === 'business') {
                        consumer.business = {
                            id: _consumer.business.id,
                            address: _consumer.business.address,
                            zipCode: _consumer.business.zipCode,
                            city: _consumer.business.city,
                            name: _consumer.business.name,
                            vatNumber: _consumer.business.vatNumber,
                        };
                    }
                    if (_consumer.mandate) {
                        consumer.mandate = {
                            id: _consumer.mandate.id,
                            holder: _consumer.mandate.holder,
                            iban: _consumer.mandate.iban,
                            signatureDate: _consumer.mandate.signatureDate,
                            membershipTypes: _consumer.mandate.membershipTypes
                        };
                    }
                    consumer.lastUpdate = oauthSigninQuery.data.status.timestamp;
                    setConsumer(consumer);
                    setIsAccount(true);
                    setIsGuest(false);
                    setIsLoginAccount(true);
                    setIsNewAccount(false);
                    setError(undefined);
                }
            }
        }
    }, [oauthSigninQuery.data]);
    // @ts-ignore
    const oauthProvider = new window.OauthComponent({
        action: 'login',
        oauthDomain: `https://${ConfigHolder.oauthDomainUrl}`,
        oauthParams: {
            role: 'consumer',
            company: api_key,
            fallback: 'register',
            language: language
        },
        onOAuthClose: _onOAuthClose,
        onOAuthComplete: _onOAuthComplete,
        onOAuthOpen: _onOAuthOpen
    });
    const doLogin = (event) => {
        var _a;
        oauthProvider.start((_a = event.target.getAttribute('data-rel')) !== null && _a !== void 0 ? _a : "google");
    };
    useEffect(() => {
        // wait after the state above is handled, then redirect to the next step
        if (flow.onNext) {
            flow.onNext();
        }
    }, [isGuest]);
    return (_jsx(_Fragment, { children: _jsxs(Box, { children: [error && (_jsx(ErrorAlert, { messages: error, setter: setError })), _jsx(Button, { onClick: doLogin, "data-rel": "google", disabled: disabled, 
                    // variant="outlined" 
                    variant: "contained", startIcon: _jsx(GoogleIcon, { sx: {
                            fontSize: '1.5rem !important',
                            fill: theme.palette.primary.contrastText
                            // fill: '#DD5044'
                        } }), sx: {
                        // borderColor: theme.palette.primary.main,
                        // color: theme.palette.primary.main,
                        textTransform: 'none',
                        my: 1
                    }, fullWidth: true, children: t('Aanmelden met Google') })] }) }));
}
